import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import RefreshIcon from "../../../assets/header/refresh.svg";
import "./inventory.css";
import { useLocation, useNavigate } from "react-router";
import { TableHeader } from "../../../components/reusableItems/header";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import {
  checkPermission,
  getUserPermission,
} from "../../../config/permission_helper";
import { fetchUserById } from "../../../store/userMgmt";
import { Reusable_table } from "../../../components/reusableItems/table";
import {
  ConfigData,
} from "./configData";
import { fetchCampaignConfig, fetchCampaigns, fetchRewards, updateCampaignStatus } from "../../../store/campaign";
import { REWARDS_INVENTORY_DETAIL } from "../../../routes";

export const RewardInventoryListing = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { searchQuery } = useLocation();
  const query = new URLSearchParams(searchQuery);
  const { campaign_list } = useSelector(
    (state) => state.campaigns
  );
  const [tempData, setTempData] = useState([]);

  const [loading, setLoading] = useState([]);
  const [campaignTypeList, setCampaignTypeList] = useState([]);
  const [tab, setTab] = useState("");
  const [tabStatus, setTabStatus] = useState("");

  const userPermissions = getUserPermission();

  const viewPermssion = checkPermission(
    userPermissions,
    "gamifications.access_reward"
  );

  const getData = async (callback) => {
    setLoading(true);


    dispatch(fetchRewards({campaign_type: tabStatus})).then((res) => {
      setLoading(false);
      
      const formattedData = res.payload.data.map(item => ({
        ...item
      }));

      setTempData(formattedData);


    });
  };


  const downloadRequiredData = async (callback) => {
    setLoading(true);
    dispatch(fetchUserById(localStorage.getItem("username"))).then(
      async (result) => {
        dispatch(fetchCampaignConfig()).then((res) => {
          const campaignNames = res.payload.data.campaign_type.map(item => item.name);
          setCampaignTypeList(campaignNames);
          if (campaignNames.length > 0) {
            setTab(campaignNames[0]);
            setTabStatus(campaignNames[0]);
          }
        });
      }
    );
  };

  useEffect(() => {
    downloadRequiredData();
  }, []);

  useEffect(() => {
    getData();
  }, [tabStatus]);

  const RefreshData = () => {
    getData();
  };



  const icons = [
    {
      icon: RefreshIcon,
      title: "Refresh",
      action: RefreshData,
    }
  ];


  const onTabChange = (tab) => {
    setTab(tab);
  };



  const handleTableClick = (type, id) => {
    navigate(`${REWARDS_INVENTORY_DETAIL}?id=`+id);

  };



  return (
    <>
      {viewPermssion ? (
        <div className="container">



          <TableHeader title={"Rewards Inventory"} icons={icons} />


          {(<div className="inventory_child_box_main_detail_box">
            <div>
              <div className="tabs">
                {campaignTypeList.map((name, index) => (
                  <>
                    <div
                      onClick={() => {
                        onTabChange(name);
                        setTabStatus(name);
                      }}
                      className={`tab ${tab === name ? "isactive" : ""}`}
                    >
                      {name}
                    </div>

                    {index !== campaignTypeList.length - 1 && (
                      <div style={{ borderLeft: "2px solid #CCCCCC" }}></div>
                    )}
                  </>
                ))}
              </div>
            </div>

            {loading ? (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100vh - 165px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            ) : (
              <Reusable_table
                header={ConfigData}
                data={tempData}
                pagination={true}
                calculatePagi={true}
                pageChangeLoading={false}
                showRow={true}
                checkbox={false}
                //   handleTableClick={handleTableClick}
                handleAction={handleTableClick}
                maxHeight={""}
                maxWidth={"calc(100vw - 240px)"}
              />
            )}
          </div>
          )}
        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};
